import React from 'react';
// template components
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import HandWithThreePlusSigns from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/HandWithThreePlusSigns';
import Umbrella from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/Umbrella';

import { ColProductCalloutStyled } from './styles';

export default () => (
  <SectionContainer
    id='physician-disabiity-insurance-callout-grouping'
    backgroundVariant='lightB'
    themeType='lightTheme'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          align='center'
          component='h2'
          nextElement='typography'>
          Options for your physician <WidowBlock>disability insurance</WidowBlock>
        </Typography>
        <Typography
          align='left'
          nextElement='graphic'>
          We&#39;ll help you understand each option and figure out which type of coverage will be right for your unique needs and your budget.
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <ColProductCalloutStyled
        medium={5}>
        <ProductCard
          icon={HandWithThreePlusSigns}
          backgroundVariant='lightA'
          cardId='product-callout-bonds-wealth-card'
          cardHeading='True Own Occupation'
          cardText={
            <>
              Should you ever become unable to perform all the duties of your occupation, you&#39;ll collect the full monthly benefit&#8212;even if you&#39;re earning an income in a different occupation.
            </>
          }
        />
      </ColProductCalloutStyled>
      <ColProductCalloutStyled
        medium={5}>
        <ProductCard
          icon={Umbrella}
          backgroundVariant='lightA'
          cardId='product-callout-physicians-disabiity-insurance-card'
          cardHeading='Medical True Own Occupation'
          cardText='This option builds on our True Own Occupation and goes a step further by giving you the flexibility to stop working and still be eligible to collect the full benefit.'
        />
      </ColProductCalloutStyled>
    </Row>
  </SectionContainer>
);
